var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2503_10600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.73528C2.25 5.5573 2.25 4.46831 2.67386 3.63643C3.0467 2.90469 3.64163 2.30977 4.37337 1.93693C5.20525 1.51306 6.29424 1.51306 8.47222 1.51306H13.5278C15.7058 1.51306 16.7948 1.51306 17.6266 1.93693C18.3584 2.30977 18.9533 2.90469 19.3261 3.63643C19.75 4.46831 19.75 5.5573 19.75 7.73528V12.7908C19.75 14.9688 19.75 16.0578 19.3261 16.8897C18.9533 17.6214 18.3584 18.2164 17.6266 18.5892C16.7948 19.0131 15.7058 19.0131 13.5278 19.0131H8.47222C6.29424 19.0131 5.20525 19.0131 4.37337 18.5892C3.64163 18.2164 3.0467 17.6214 2.67386 16.8897C2.25 16.0578 2.25 14.9688 2.25 12.7908V7.73528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.27031L15.9999 8.29687C15.9999 8.30806 15.9998 8.31925 15.9996 8.33044C15.9999 8.3435 16 8.35666 16 8.36995C16 10.4551 14.3755 12.3008 13.2884 13.536C12.9729 13.8944 12.7027 14.2014 12.5306 14.4478C11.9184 15.3247 11.5952 16.2746 11.5102 16.6399C11.5102 16.915 11.2818 17.1381 11 17.1381C10.7182 17.1381 10.4898 16.915 10.4898 16.6399C10.4048 16.2746 10.0816 15.3247 9.46939 14.4478C9.29727 14.2014 9.02708 13.8944 8.71164 13.536C7.62454 12.3008 6 10.4551 6 8.36995C6 8.35666 6.00012 8.3435 6.00037 8.33044C6.00012 8.31042 6 8.29038 6 8.27031C6 5.57391 8.23857 3.38806 11 3.38806C13.7614 3.38806 16 5.57391 16 8.27031ZM11 10.0638C12.0708 10.0638 12.9388 9.21621 12.9388 8.17067C12.9388 7.12513 12.0708 6.27755 11 6.27755C9.92924 6.27755 9.06122 7.12513 9.06122 8.17067C9.06122 9.21621 9.92924 10.0638 11 10.0638Z",
    fill: "#34A851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4408 6.02466C14.8285 4.87272 13.76 3.98917 12.4689 3.60229L9.59729 6.86397C9.95035 6.50276 10.4483 6.27772 11 6.27772C12.0707 6.27772 12.9388 7.1253 12.9388 8.17084C12.9388 8.59736 12.7943 8.99095 12.5506 9.30748L15.4408 6.02466Z",
    fill: "#4285F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76954 13.602C8.75039 13.5802 8.73106 13.5583 8.71155 13.5361C7.99498 12.7219 7.04488 11.6425 6.48047 10.404L9.46505 7.01404C9.21182 7.33394 9.06114 7.73517 9.06114 8.17079C9.06114 9.21633 9.92915 10.0639 10.9999 10.0639C11.5423 10.0639 12.0327 9.84641 12.3846 9.49588L8.76954 13.602Z",
    fill: "#F9BB0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18305 5.11658C6.44505 5.96734 6 7.0681 6 8.27037C6 8.29044 6.00012 8.31048 6.00037 8.3305C6.00012 8.34356 6 8.35672 6 8.37C6 9.0807 6.18872 9.76359 6.48056 10.404L9.46011 7.01969L7.18305 5.11658Z",
    fill: "#E74335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 3.60215C12.0043 3.46298 11.5111 3.38806 10.9999 3.38806C9.46976 3.38806 8.10014 4.05923 7.18298 5.11652L9.46004 7.01961L9.465 7.01399C9.50642 6.96166 9.55057 6.9115 9.59727 6.86373L12.4688 3.60215Z",
    fill: "#1A73E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2503_10600",
    x: -1,
    y: -0.736938,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2503_10600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2503_10600",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3d03d0ea961dc8864767a881fd68d9a5.svg";
export { ForwardRef as ReactComponent };